import type { TextareaHTMLAttributes } from 'react';
import { cn } from '@/lib/cn';

interface TextAreaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  label?: string;
  hint?: string;
  errorText?: string;
}

export function TextArea({ label, hint, errorText, id, className, ...rest }: TextAreaProps) {
  const fieldId = id ?? (label ? `field-${label.toLowerCase().replace(/[^a-z0-9]+/g, '-')}` : undefined);
  return (
    <div className="flex flex-col gap-1.5">
      {label ? (
        <label htmlFor={fieldId} className="text-sm font-medium text-ink">
          {label}
        </label>
      ) : null}
      <textarea
        id={fieldId}
        rows={3}
        className={cn(
          'rounded-lg border bg-surface px-3 py-2 text-sm text-ink',
          'placeholder:text-ink-subtle focus:outline-none focus:ring-2 focus:ring-brand',
          errorText ? 'border-danger' : 'border-line',
          className,
        )}
        {...rest}
      />
      {errorText ? (
        <p className="text-xs text-danger">{errorText}</p>
      ) : hint ? (
        <p className="text-xs text-ink-subtle">{hint}</p>
      ) : null}
    </div>
  );
}
